import api from '@/lib/api';

/**
 * @param {{ media_type: string, provider: string, mode?: string, duration_seconds?: number }} params
 */
export async function fetchCreditQuote({
  media_type,
  provider,
  mode = 'default',
  duration_seconds = 8,
}) {
  const { data } = await api.post('/billing/quote', {
    media_type,
    provider: String(provider || 'default').toLowerCase(),
    mode: mode || 'default',
    duration_seconds: Number(duration_seconds) || 8,
  });
  return data;
}

/** @param {Record<string, unknown> | null | undefined} quote */
export function formatCreditEstimate(quote) {
  const credits = Number(quote?.credits || 0);
  if (!credits || credits <= 0) return null;
  const creditsStr = credits.toFixed(2);
  const inr = quote?.cost_inr != null ? Number(quote.cost_inr).toFixed(2) : null;
  return inr ? `${creditsStr} credits (≈ ₹${inr})` : `${creditsStr} credits`;
}

const SLIDESHOW_PROVIDERS = new Set(['narration_slideshow', 'nano_banana', 'slideshow']);

export function isSlideshowVideoProvider(provider) {
  return SLIDESHOW_PROVIDERS.has(String(provider || '').toLowerCase());
}

/**
 * Map UI video engine to billing provider id (null = no video API charge).
 */
export function billingProviderForVideo(engine, { isNarrationMode, story } = {}) {
  const e = String(engine || '').toLowerCase();
  if (isNarrationMode) {
    if (e === 'nano_banana') {
      const p = story?._narrationVideoProvider || 'narration_slideshow';
      return isSlideshowVideoProvider(p) ? null : p;
    }
    return isSlideshowVideoProvider(e) ? null : e;
  }
  return isSlideshowVideoProvider(e) ? null : e;
}

export function sceneBillingDurationSeconds(scene) {
  const d =
    scene?.audio_duration_seconds
    ?? scene?.audio_duration
    ?? scene?.duration_seconds
    ?? scene?.duration
    ?? 8;
  return Math.max(1, Number(d) || 8);
}
